export default __webpack_public_path__ + "static/media/ImageRight.5694d72c.svg";